export default "__VITE_ASSET__OibHyqNR__"